import React from 'react'
import ReactDOM from 'react-dom'
import App from './pages/Home'
import './styles/global.css'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
